import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from "reactstrap";

// Import images
import homeImage from "../../images/app/home.png";

class Section extends Component {
    render() {
        return (
            <React.Fragment>
                <section className="bg-half-100 d-table w-100" id="home">
                            <Container>
                                <Row className="align-items-center">
                                    <Col lg={6} md={7} >
                                        <div className="title-heading mt-1">
                                            <h1 className="heading mb-3">Maneja tus gastos de forma inteligente</h1>
                                            <p className="para-desc text-muted">¿Frustrado con rendir gastos de forma manual?. Con Rindo sacas una fotos, un par de  clics y listo!. Reduce al máximo tus tiempos de gestión y costos, entregando seguridad y disminuyendo tus actividades.</p>
                                            <div className="mt-4">
                                                {/* <a href="https://id.rindoapp.com/signup" className="btn btn-primary mt-2 mr-2">Prueba Gratis Rindo</a> */}
                                                <a href="https://calendly.com/jpbarahona/demo-rindo" target="_blank" className="btn btn-primary mt-2 mr-2">Solicita una Demo</a>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={5} md={5} className="mt-4 pt-2 mt-sm-0 pt-sm-0">
                                    <div className="text-md-right text-center">
                                        <img src={homeImage} className="img-fluid" alt="" />
                                    </div>
                                    </Col>
                                </Row>
                            </Container>
                </section>
            </React.Fragment>
        );
    }
}

export default Section;